import styled, { css } from 'styled-components';
import {
	media, variables
} from 'styleUtils';

const Wrapper = styled.div`
  height: auto;
  width: 100%;
`;

const LimitedTimeOffer = styled.div`
  text-align: center;
  height: 70px;
  padding: 15px;
  margin-bottom: 10px;
  background-image: linear-gradient(to right, #FFCFBE, #FFF980 , #94CFC4);
  ${props => props.upsell && css`
    height: 35px;
    padding: 9px;
    margin-top: 0px;
    margin-bottom:: 0;
  `}
  ${media.tablet`
    margin-top: 22px;
  `}
  ${media.desktop`
    ${props => !props.upsell && 'display: none;'}
  `}
  h3 {
    text-transform: uppercase;
    font-family: 'GT-Pressura';
    font-size: 14px;
    margin-bottom: 0;
  }
  p {
  
  }
`;

const ConfirmationWrapper = styled.div`
  width: 95%;
  background-color: white;
  margin: 0 auto;
  max-width: 360px;
  box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);
  ${props => !props.crossSellInfo && 'margin-top: 30px;'}
  ${props => props.otc && 'padding-bottom: 20px;'}
  ${media.tablet`
    max-width: 550px;
    ${props => !props.crossSellInfo && 'margin-top: 50px;'}
  `}
  ${media.desktop`
    max-width: 900px;
    margin-top: 70px;
    ${props => props.otc && 'padding-bottom: 60px;'}
  `}
`;

const UpsellWrapper = styled.div`
  width: 95%;
  background-color: white;
  margin: 0 auto;
  max-width: 360px;
  margin-top: 10px;
  padding-bottom: 35px;
  box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);
  p {
    max-width: 250px;
    margin: 0 auto;
    text-align: center;
    &.mobile {
      ${media.desktop`
        display: none;
      `}
    }
    ${media.desktop`
      font-size: 20px;
      max-width: 100%;
    `}
  }
  h5 {
    font-size: 48px;
    margin: 15px auto;
    margin-top: 8px;
    max-width: 30px;
  }
  ${media.tablet`
    max-width: 550px;
    ${props => props.exclusive && 'margin-top: 60px;'}
  `}
  ${media.desktop`
    max-width: 900px;
  `}
`;

const YellowTop = styled.div`
  height: 15px;
  width: 100%;
  background-color: ${variables.newYellow};
`;

const TextWrapper = styled.div`
  text-align: center;
  padding: 20px;
  ${media.tablet`
    max-width: 450px;
    margin: 0 auto;
  `}
  ${media.desktop`
    max-width: 530px;
    margin-top: 20px;
  `}
  h1 {
    margin-bottom: 25px;
    ${media.desktop`
      font-size: 36px;
      display: flex;
    `}
  }
  p {
    font-size: 16px;
    ${media.desktop`
      margin: 10px auto;
    `}
  }
  .confirm {
    margin-bottom: 0;
    ${media.desktop`
      display: inline-block;
      margin-right: 8px;
    `}
  }
  .email {
    margin-top: 0;
    ${media.desktop`
      display: inline-block;
    `}
  }
`;

const OrderDetails = styled.div`
  width: 95%;
  padding: 20px 25px;
  border: 1px solid lightgray;
  margin: 0 auto;
  margin-bottom: 30px;
  ${media.desktop`
    width: 320px;
    margin-bottom: 0;
  `}
  h1 {
    text-align: center;
    font-size: 18px;
    margin-bottom: 20px;
  }
  p {
    color: #8B8A87;
    font-size: 14px;
    margin: 2.5px 0;
  }
  hr {
    background-color: lightgray;
    margin: 10px 0;
  }
`;

const OrderSummary = styled.div`
  width: 95%;
  padding: 20px 25px;
  margin: 0 auto;
  height: auto;
  ${props => !props.confirmation && css`box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);`}
  ${media.desktop`
    width: 350px;
    min-height: 263px;
  `}
  .title {
    text-align: center;
    font-size: 18px;
    margin-bottom: 20px;
    color: #000000;
    ${media.desktop`
      padding-bottom: 0;
    `}
  }
  .cart {
    
  }
  .cart-item {
    padding: 0px 10px;
  }
  .cart-item-total {
    background-color: transparent;
    padding: 5px 10px;
  }
  hr {
    background-color: lightgray;
    margin: 10px 0;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px;
  ${props => props.button && css`
    a {
      margin: 40px auto;
      margin-bottom: 0;
      width: 260px;
      border-radius: 100px;
      text-decoration: none;
      border: 1px solid #000000;
      background-color: white;
      color: #000000;
      text-align: center;
      padding: 20px 25px;
      cursor: pointer;
      line-height: 1;
      ${media.desktop`
        width: 290px;
        height: 60px;
        margin-bottom: 20px;
      `}
    }
  `}
`;

const OrderWrapper = styled.div`
  ${media.desktop`
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
  `}
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 310px;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 15px;
  ${media.desktop`
    width: 580px;
    margin-top: 50px;
    margin-bottom: 30px;
  `}
  h1 {
    margin: 0;
  }
`;

const Savings = styled.div`
  position: relative;
  background-color: ${variables.newYellow};
  display: flex;
  justify-content: space-between;
  width: 220px;
  height: 119px;
  margin: 40px auto;
  padding: 12px 15px 12px 15px;
  border-radius: 17px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.09);
  ${media.desktop`
    margin-top: 85px;
    width: 440px;
    height: auto;
    flex-wrap: wrap;
    margin-bottom: 20px;
  `}
  p {
    display: none;
    ${media.desktop`
      display: block;
      min-width: 100%;
      font-size: 16px;
      margin-top: 50px;
      margin-bottom: 10px;
    `}
  }
  hr {
    transform: rotate(90deg);
    position: absolute;
    background-color: black;
    height: 1px;
    width: 95px;
    top: 60px;
    left: 62px;
    margin: 0;
    ${media.desktop`
      width: 160px;
      top: 103px;
      left: 140px;
    `}
  }
`;

const SavingsText = styled.div`
  width: 78px;
  text-align: center;
  margin-top: 10px;
  ${media.desktop`
    width: 200px;
    margin-top: 35px;
  `}
  h3 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 0;
    ${media.desktop`
      font-size: 48px;
    `}
  }
  h4 {
    font-size: 20px;
    margin-bottom: 5px;
    ${media.desktop`
      font-size: 32px;
    `}
  }
`;

const SealWrapper = styled.div`
  position: absolute;
  height: 55px;
  width: 55px;
  top: -28px;
  left: -29px;
  ${media.desktop`
    height: 125px;
    width: 125px;
    top: -57px;
    left: -61px;
  `}
  svg {
    width: 100%;
    height: 100%;
  }
`;

const ButtonWrapper = styled.div`
  margin: 30px auto;
  width: 260px;
  ${media.desktop`
    width: 290px;
    height: 60px;
    margin-top: 40px;
    margin-bottom: 20px;
  `}
  button {
    width: 100%;
    height: 100%;
    ${media.desktop`
      font-size: 16px;
    `}
  }
`;

const CheckWrapper = styled.div`
  display: none;
  ${media.desktop`
    display: inline-block;
    height: 45px;
    width: 45px;
    margin-right: 15px;
  `}
  svg {
    width: 100%;
    height: 100%;
    margin-top: 2px;
    path {
      fill: #000000;
    }
  }
`;

export {
	ButtonWrapper,
	CheckWrapper,
	ConfirmationWrapper,
	LimitedTimeOffer,
	LinkWrapper,
	OrderDetails,
	OrderSummary,
	OrderWrapper,
	Savings,
	SavingsText,
	SealWrapper,
	TextWrapper,
	TitleWrapper,
	UpsellWrapper,
	Wrapper,
	YellowTop,
};
